import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useTheme,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { IContract, ILogicalCheck } from "../../../../../../types/contract";
import { DialogMode } from "../../../../../../types/dialogmode";

import { getAllLogicalChecks } from "../InsightsSummaryCards";

interface RisksTabProps {
  contract: IContract;
  mode: DialogMode;
  riskLevel?: "high" | "medium" | "low";
}

const RisksTab: React.FC<RisksTabProps> = ({ contract, mode, riskLevel }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [logicalChecks, setLogicalChecks] = useState<
    { component: string; risks: ILogicalCheck }[]
  >([]);

  useEffect(() => {
    if (contract) {
      const newLogicalChecks = getAllLogicalChecks(contract);
      setLogicalChecks(newLogicalChecks as any);
    }
  }, [contract]);

  return (
    <Stack>
      {logicalChecks?.map((check, index) => (
        <Accordion key={index}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-${index}`}
            id={`panel-${index}-header`}
          >
            <ListItem disablePadding disableGutters>
              <ListItemText primary={t(check?.component)} />
            </ListItem>
          </AccordionSummary>
          <AccordionDetails>
            {/* <pre>{JSON.stringify(check, null, 2)}</pre> */}
            <Typography variant="body2" color={theme.palette.text.secondary}>
              {check?.risks?.logic_check?.explanation}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  );
};

export default RisksTab;
